import { createSlice } from "@reduxjs/toolkit";
import { qbdItemsAction } from "redux/action/itemsAction";
import { toastText } from "utils/utils";

const initialState: any = {
  data: null,
  isLoading: false,
  error: null,
};

const QbdItemSlice = createSlice({
  name: "qbdItems",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(qbdItemsAction.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(qbdItemsAction.fulfilled, (state, action: any) => {
      state.isLoading = false;
      state.data = action?.payload;
    });
    builder.addCase(qbdItemsAction.rejected, (state, action: any) => {
      state.isLoading = false;
      state.error = action.payload;
      toastText(action?.payload?.message, "error");
    });
  },
});

export default QbdItemSlice;
